import { observable } from "mobx";
import { Type } from "class-transformer";
import DeadLetterTopicActionType from "./deadLetterTopicActionType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class DeadLetterTopicMessageActionResponse {
  id!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  type!: DeadLetterTopicActionType;

  @observable
  createdBy!: string;

  @observable
  messageCount!: number;
}

export default class DeadLetterTopicMessageAction extends DeadLetterTopicMessageActionResponse {
  @observable
  isSelectable: boolean = true;
}
